module.exports = __webpack_public_path__ + "static/media/ewalletIcon.47674c93.svg";